import {
    MutationCache,
    QueryCache,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import toast from 'react-hot-toast'
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'
import {AuthProvider} from 'features/common/context/auth'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: Infinity,
            retry: false,
        },
    },
    queryCache: new QueryCache({
        onError: (err) => {
            toast.error((err as Error).message)
        },
    }),
    mutationCache: new MutationCache({
        onError: (err) => {
            toast.error((err as Error).message)
        },
    }),
})

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <App />
            </AuthProvider>
        </QueryClientProvider>
    </React.StrictMode>,
)

reportWebVitals()
